import React from "react";
import { SortDirection } from "models/SortDirection.model";
import {
  ApplicationHistorySortCriteria,
  ApplicationHistorySortCriteriaUtil,
} from "models/ApplicationHistorySortCriteria.model";
import { SortingState } from "@tanstack/react-table";

export const useSortParticipantHistory = () => {
  const [sorting, setSorting] = React.useState<SortingState>([
    { id: ApplicationHistorySortCriteria.Created, desc: true },
  ]);

  const sortDirection = React.useMemo(() => {
    const [{ desc }] = sorting;
    if (desc) {
      return SortDirection.Descending;
    }

    return SortDirection.Ascending;
  }, [sorting]);

  const sortCriteria = React.useMemo(() => {
    const [{ id }] = sorting;

    return ApplicationHistorySortCriteriaUtil.parse(id);
  }, [sorting]);

  return {
    sortDirection,
    sortCriteria,
    onSortingChange: setSorting,
  };
};
